import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorImageDirective } from './error-image.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [ErrorImageDirective],
  exports: [ErrorImageDirective],
})
export class ErrorImageModule {}
